/** Stable pseudo-random avatar per WebSocket `connection_id` (Channels channel name). */

const GLYPHS = [
  "🐶",
  "🐱",
  "🐭",
  "🐹",
  "🐰",
  "🦊",
  "🐻",
  "🐼",
  "🐨",
  "🐯",
  "🦁",
  "🐮",
  "🐷",
  "🐸",
  "🐵",
  "🐔",
  "🐧",
  "🐦",
  "🦆",
  "🦉",
  "🦇",
  "🐺",
  "🦄",
  "🐝",
  "🦋",
] as const;

function hashString(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = Math.imul(31, h) + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export function bluffAvatarEmoji(connectionId: string): string {
  if (!connectionId) return GLYPHS[0];
  return GLYPHS[hashString(connectionId) % GLYPHS.length];
}
